import { render, staticRenderFns } from "./list1.vue?vue&type=template&id=5a014fbd&scoped=true"
import script from "./list1.vue?vue&type=script&lang=js"
export * from "./list1.vue?vue&type=script&lang=js"
import style0 from "./list1.vue?vue&type=style&index=0&id=5a014fbd&prod&lang=scss&scoped=true"
import style1 from "./list1.vue?vue&type=style&index=1&id=5a014fbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a014fbd",
  null
  
)

export default component.exports